<div class="input_box">

    <mat-form-field appearance="fill" class="form-field">
        <mat-label>{{inputParameters.name}} ({{languageService.Strings.timeFieldStrings.information_Hours}})</mat-label>
        <input 
            *ngIf="inputParameters.required"
            matInput
            type="number"
            [formControl]="hoursControl"
            [errorStateMatcher]="matcher" 
            min="0" step="1"
            required
            autocomplete="off"/>
        <input 
            *ngIf="!inputParameters.required"
            matInput
            type="number"
            [formControl]="hoursControl"
            [errorStateMatcher]="matcher" 
            min="0" step="1"
            autocomplete="off"/>

        <mat-error *ngIf="(hoursControl.hasError('max'))">
            {{languageService.Strings.errorMessages.error_maxValue}}
        </mat-error>
        <mat-error *ngIf="(hoursControl.hasError('min'))">
            {{languageService.Strings.errorMessages.error_minValue}}
        </mat-error>
        <mat-error *ngIf="(hoursControl.hasError('integerValidationError'))">
            {{languageService.Strings.errorMessages.error_step}}
        </mat-error>
      </mat-form-field>
    
      <mat-form-field appearance="fill" class="form-field">
        <mat-label>{{inputParameters.name}} ({{languageService.Strings.timeFieldStrings.information_Minutes}})</mat-label>
        <input
            *ngIf="inputParameters.required"
            matInput
            type="number"
            [formControl]="minutesControl"
            [errorStateMatcher]="matcher" 
            min="0" max="59" step="1"
            required
            autocomplete="off"/>
        <input
            *ngIf="!inputParameters.required"
            matInput
            type="number"
            [formControl]="minutesControl"
            [errorStateMatcher]="matcher" 
            min="0"  max="59" step="1"
            autocomplete="off"/>

        <mat-error *ngIf="(minutesControl.hasError('max'))">
            {{languageService.Strings.errorMessages.error_maxValue}}
        </mat-error>
        <mat-error *ngIf="(minutesControl.hasError('min'))">
            {{languageService.Strings.errorMessages.error_minValue}}
        </mat-error>
        <mat-error *ngIf="(minutesControl.hasError('integerValidationError'))">
            {{languageService.Strings.errorMessages.error_step}}
        </mat-error>
      </mat-form-field>
    
      <mat-form-field appearance="fill" class="form-field">
        <mat-label>{{inputParameters.name}} ({{languageService.Strings.timeFieldStrings.information_Seconds}})</mat-label>
        <input 
            *ngIf="inputParameters.required"
            matInput 
            type="number"
            [formControl]="secondsControl"
            [errorStateMatcher]="matcher" 
            min="0"  max="59" step="1"
            required
            autocomplete="off"/>
        <input 
            *ngIf="!inputParameters.required"
            matInput 
            type="number"
            [formControl]="secondsControl"
            [errorStateMatcher]="matcher" 
            min="0"  max="59" step="1"
            autocomplete="off"/>

            <mat-error *ngIf="(secondsControl.hasError('max'))">
                {{languageService.Strings.errorMessages.error_maxValue}}
            </mat-error>
            <mat-error *ngIf="(secondsControl.hasError('min'))">
                {{languageService.Strings.errorMessages.error_minValue}}
            </mat-error>
            <mat-error *ngIf="(secondsControl.hasError('integerValidationError'))">
                {{languageService.Strings.errorMessages.error_step}}
            </mat-error>
      </mat-form-field>
    

</div>
